import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const DeleteConfirmationDialog = ({ onClose, onYes, name }) => {
    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '16px' }}>Delete the {name}</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Typography>Are you sure you want to delete this {name}?</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onYes}>Yes</Button>
            </DialogActions>
        </Dialog>
    );
};

DeleteConfirmationDialog.propTypes = {
    onClose: PropTypes.func,
    onYes: PropTypes.func,
    name: PropTypes.string
};

export default DeleteConfirmationDialog;
